import { useEffect } from 'react'

interface DocumentMetaProps {
  title?: string
  description?: string
}

export function useDocumentMeta({ title, description }: DocumentMetaProps) {
  useEffect(() => {
    if (title) {
      document.title = title
    }

    if (description) {
      let metaDescription = document.querySelector('meta[name="description"]')
      if (!metaDescription) {
        metaDescription = document.createElement('meta')
        metaDescription.setAttribute('name', 'description')
        document.head.appendChild(metaDescription)
      }
      metaDescription.setAttribute('content', description)
    }
  }, [title, description])
}
